export enum EMissionBonusGroupKey {
  // L0 = "GR_CASH_5",
  L0 = 'love_quest_entry',
  // L1 = "GR_CASH_5",
  L1 = 'love_quest_l1',
  L2 = 'love_quest_l2',
  // L3 = "GR_CASH_5",
  L3 = 'love_quest_l3',
  L4 = 'love_quest_4',
  L5 = 'love_quest_l5',
}

export const MISSION_BONUS_GROUP_KEYS = Object.values(EMissionBonusGroupKey);

export const MISSION_LOTBOXES_GROUP_KEYS = [
  EMissionBonusGroupKey.L3,
  EMissionBonusGroupKey.L5,
];

export const MAP_BONUS_GROUP_KEY_TO_CHARACTER: Record<
  EMissionBonusGroupKey,
  number
> = {
  [EMissionBonusGroupKey.L0]: 0,
  [EMissionBonusGroupKey.L1]: 1,
  [EMissionBonusGroupKey.L2]: 2,
  [EMissionBonusGroupKey.L3]: 3,
  [EMissionBonusGroupKey.L4]: 4,
  [EMissionBonusGroupKey.L5]: 5,
};
